// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"3656631c","73":"7473f0f8","94":"b99b7341","102":"c5740d62","134":"6d4aa338","140":"71b7970d","144":"880f09f3","461":"8a836306","514":"46a25f82","610":"07d7095d","646":"8c647cc0","655":"57f4e24a","688":"a095d83e","918":"430b758c","929":"689708e5"}[chunkId] + ".chunk.js";
};